
export function ClearCart(itemData)
{
    return(
        { 
            type: 'clear_cart',
            payload: itemData,
        }
    )
}